import { useFormik } from "formik"
import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import * as Yup from "yup"
import { Col, Row, Form, Label, Input, FormFeedback } from "reactstrap"
import { uploadCategory } from "store/manageclient/action"
import { isEmpty } from "lodash"
import Select from "react-select"

const ClientForm = ({
  handleCancel,
  isEdit,
  toggle,
  selectedRow,
  companySetting,
  companyid,
  getallagentslist,
  agent,
  setAgent
}) => {
  const dispatch = useDispatch()


  useEffect(() => {
    if (isEdit) {
      setAgent({
        label: selectedRow?.agentInfo?.agentName,
        value: selectedRow?.agentInfo?.agentID,
        name: selectedRow?.agentInfo?.agentName,
        id: selectedRow?.agentInfo?.agentID,
      })
    }
  }, [selectedRow])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    
    initialValues: {
      categoryId: selectedRow.categoryId,
      categoryname: isEdit ? selectedRow?.categoryName.split(" ").join("") : "",
      fullname: isEdit ? selectedRow?.fullName : "",
      Suspend: isEdit ? selectedRow?.suspend : false,
      OpenLink: isEdit ? selectedRow?.openLink : true,
      subCategoryCreation: isEdit ? selectedRow?.subCategoryCreation : false,
      subCategoryAdminCreate: isEdit
        ? selectedRow?.subCategoryAdminCreate
        : true,
      restrictbyAssignedUser: isEdit
        ? selectedRow?.restrictbyAssignedUser
        : true,
      BillingProblem: isEdit ? (selectedRow?.billingProblem ? true : false)  : false,
      agentID: isEdit ? selectedRow?.agentInfo?.agentID || {} : "",
      fromEmail: isEdit ? selectedRow?.reportFromEmail : "",
      doNotSendDailyWorkReport : isEdit ? selectedRow?.doNotSendDailyWorkReport :false
    },
    validationSchema: Yup.object({
      categoryname: Yup.string().required(
        `Please Enter ${companySetting.MainCategory} Name`
      ),
      fromEmail: Yup.string().email("Invalid email").nullable().notRequired(),
      fullname: Yup.string().required("Please Enter Full Name"),
      agentID: Yup.string().required("Please Select Agent Name").nullable(),
    }),
    onSubmit: values => {
      debugger;
      if (isEdit) {
        const updateclient = {
          categoryId: values.categoryId,
          companyId: companyid,
          categoryname: values?.categoryname,
          fullname: values?.fullname,
          Suspend: values?.Suspend,
          OpenLink: values?.OpenLink,
          subCategoryCreation: values?.subCategoryCreation,
          subCategoryAdminCreate: values?.subCategoryAdminCreate,
          restrictByAssignedUser: values?.restrictbyAssignedUser,
          BillingProblem: values?.BillingProblem,
          agentID: parseInt(values?.agentID),
          fromEmail: values?.fromEmail || "",
          doNotSendDailyWorkReport : values?.doNotSendDailyWorkReport,
        }
        dispatch(uploadCategory(updateclient, handleResponse))
      } else {
        const newcategory = {
          categoryname: values?.categoryname,
          fullname: values?.fullname,
          Suspend: values?.Suspend,
          OpenLink: values?.OpenLink,
          subCategoryCreation: values?.subCategoryCreation,
          subCategoryAdminCreate: values?.subCategoryAdminCreate,
          restrictByAssignedUser: values?.restrictbyAssignedUser,
          BillingProblem: values?.BillingProblem,
          agentID: parseInt(values?.agentID),
          fromEmail: values?.fromEmail || "",
          doNotSendDailyWorkReport : values?.doNotSendDailyWorkReport,
        }
        dispatch(uploadCategory(newcategory, handleResponse))
      }
    },
  })
  const handleResponse = status => {
    if (status === "SUCCESS") {
      toggle()
      validation.resetForm()
    }
  }
  const bindfullname = e => {
    validation.setFieldValue("fullname", e.target.value)
    if (isEmpty(selectedRow?.categoryName)) {
      validation.setFieldValue(
        "categoryname",
        e.target.value.split(" ").join("")
      )
    }
  }

  const onSelectAgent = value => {
    setAgent(value)
    validation.setFieldValue("agentID", value?.id?.toString())
  }

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      // Customize the control (main input) styles
      // background: !state?.isSelected ? "#e69138" : "white",

      borderColor:
        validation.touched.agentID && validation.errors.agentID
          ? "#f46a6a !important"
          : "#FFDBB1 !important",
      "& svg": {
        color:
          validation.touched.agentID && validation.errors.agentID
            ? "#f46a6a !important"
            : "green !important",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      // Customize the option styles
      background: state?.isSelected ? "#e69138" : "white",
      "&:hover": {
        background: "#f4c896", // Change option background color on hover
        color: "#fff", // Change option text color on hover
      },
      borderColor:
        validation.touched.agentID && validation.errors.agentID
          ? "#f46a6a !important"
          : "#FFDBB1 !important",
      // color: 'black',
    }),
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        validation.handleSubmit()
        return false
      }}
    >
      <Row form>
        <Col>
          <div className="mb-3">
            <Label className="form-label">Full Name</Label>
            <Input
              id="fullname"
              name="fullname"
              className="form-control"
              placeholder="Enter  Name"
              type="text"
              onChange={value => bindfullname(value)}
              onBlur={validation.handleBlur}
              value={validation.values.fullname || ""}
              invalid={
                validation.touched.fullname && validation.errors.fullname
                  ? true
                  : false
              }
            />
            {validation.touched.fullname && validation.errors.fullname ? (
              <FormFeedback type="invalid">
                {validation.errors.fullname}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label className="form-label">{`${companySetting.MainCategory} Name`}</Label>
            <Input
              id="categoryname"
              name="categoryname"
              className="form-control"
              placeholder={`Enter ${companySetting.MainCategory} Name`}
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.categoryname.replace(/^\s+|\s+$/g, "")}
              invalid={
                validation.touched.categoryname &&
                validation.errors.categoryname
                  ? true
                  : false
              }
            />
            {validation.touched.categoryname &&
            validation.errors.categoryname ? (
              <FormFeedback type="invalid">
                {validation.errors.categoryname}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label className="form-label">Agent Name</Label>
            <Select
              styles={customStyles}
              classNamePrefix="select2-selection"
              value={agent}
              onChange={value => onSelectAgent(value)}
              placeholder={"Select Agent"}
              options={(getallagentslist || [])?.map(el => ({
                ...el,
                label: el.name,
                value: el.id,
              }))}
            />
            {validation.touched.agentID && validation.errors.agentID ? (
              <div style={{ color: "#f46a6a", fontSize: 10.4, marginTop: 5 }}>
                {" "}
                {validation.errors.agentID}
              </div>
            ) : null}
          </div>
          {/* Ability to Add / Update from Email address for specific category */}
          <div className="mb-3">
            <Label className="form-label">Report From Email</Label>
            <Input
              id="fromEmail"
              name="fromEmail"
              className="form-control"
              placeholder="Enter Report From Email"
              type="email"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.fromEmail}
              invalid={
                validation.touched.fromEmail && validation.errors.fromEmail
                  ? true
                  : false
              }
            />
            {validation.touched.fromEmail && validation.errors.fromEmail ? (
              <FormFeedback type="invalid">
                {validation.errors.fromEmail}
              </FormFeedback>
            ) : null}
          </div>
          <Row>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.Suspend}
                  id="Suspend"
                />
                <Label className="form-check-label" htmlFor="Suspend">
                  Suspend
                </Label>
              </div>
            </Col>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.OpenLink}
                  id="OpenLink"
                />
                <Label className="form-check-label" htmlFor="OpenLink">
                  OpenLink
                </Label>
              </div>
            </Col>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.subCategoryCreation}
                  id="subCategoryCreation"
                />
                <Label
                  className="form-check-label"
                  htmlFor="subCategoryCreation"
                >
                  {`${companySetting?.SubCategory} Creation`}
                </Label>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.subCategoryAdminCreate}
                  id="subCategoryAdminCreate"
                />
                <Label
                  className="form-check-label"
                  htmlFor="subCategoryAdminCreate"
                >
                  {`${companySetting?.SubCategory} Admin Create`}
                </Label>
              </div>
            </Col>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values.restrictbyAssignedUser}
                  id="restrictbyAssignedUser"
                />
                <Label
                  className="form-check-label"
                  htmlFor="restrictbyAssignedUser"
                >
                  {` ${companySetting.MainCategory} Trac User Restricted`}
                </Label>
              </div>
            </Col>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values.BillingProblem}
                  id="BillingProblem"
                />
                <Label
                  className="form-check-label"
                  htmlFor="BillingProblem"
                >
                  Billing Problem Stop Work
                </Label>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.doNotSendDailyWorkReport}
                  id="doNotSendDailyWorkReport"
                />
                <Label
                  className="form-check-label"
                  htmlFor="doNotSendDailyWorkReport"
                >
                  Do Not Send Daily WorkReport
                </Label>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="text-end">
        <button type="submit" className="btn btn-primary save-customer me-2">
          Save
        </button>
        <button
          type="button"
          color="primary"
          className="btn btn-secondary"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </div>
    </Form>
  )
}

export default ClientForm
